export default {
    region: 'eu-central-1',
    UserPoolId: 'eu-central-1_WhA1MQYQm',
    ClientId: '3qbk3uelhsov5unjhad95hsrjb',
}
